module.exports = __webpack_public_path__ + "img/virtual_fan_4.e544ddc.jpg";